export function isPromotionCurrentlyActive(seller, now = new Date()) {
  if (!seller?.promotionActive) return false;
  if (seller.promotionStartsAt) {
    const starts = new Date(seller.promotionStartsAt);
    if (!Number.isNaN(starts.getTime()) && starts > now) return false;
  }
  if (seller.promotionExpiresAt) {
    const expires = new Date(seller.promotionExpiresAt);
    if (!Number.isNaN(expires.getTime()) && expires <= now) return false;
  }
  return true;
}
